module.exports = __webpack_public_path__ + "img/educate.a5f5664e.jpg";